// Copyright (c) 2023 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import {PanelHeaderFactory, SaveExportDropdownFactory, Icons, AppLogo as KeplerGlLogo} from '@kepler.gl/components';
import React, {useCallback} from 'react';

const CustomKeplerGlLogo = (props) => (
  <KeplerGlLogo
    {...props}
    appName="Vista"
    appWebsite="https://www.mobilitylab.co.nz/"
    version="Powered by Mobility Lab"
  />
);

const CustomSaveExportDropdownFactory = (...deps) => {
  const SaveExportDropdown = SaveExportDropdownFactory(...deps);

  const CustomSaveExportDropdown = (props) => {
    const customItems = [
      {
        label: 'toolbar.exportImage',
        icon: Icons.Picture,
        key: 'image',
        onClick: props => props.onExportImage
      },
      {
        label: 'toolbar.exportData',
        icon: Icons.DataTable,
        key: 'data',
        onClick: props => props.onExportData
      },
      {
        label: 'toolbar.shareMapURL',
        icon: Icons.Share,
        key: 'share',
        onClick: props => props.onShareMap
      },
      {
        label: 'Sessions',
        icon: Icons.Play,
        key: 'session',
        onClick: props => props.onSaveToStorage
      }
    ];

    return <SaveExportDropdown {...props} items={customItems} />;
  };

  return CustomSaveExportDropdown;
};

CustomSaveExportDropdownFactory.deps = SaveExportDropdownFactory.deps;

export function CustomPanelHeaderFactory(...deps) {

  const PanelHeader = PanelHeaderFactory(...deps);

  const CustomPanelHeader = (props) => {
    const customActionItems = [
      // ...PanelHeader.defaultProps.actionItems.filter(item => item.id !== 'save' && item.id !== 'config'),
      {
        id: 'config',
        iconComponent: Icons.Save2,
        blank: true,
        tooltip: 'Save Map Config',
        onClick: () => {
          props.onSaveMap && props.onSaveMap();
        }
      },
      {
        ...PanelHeader.defaultProps.actionItems.find(item => item.id === 'save'),
        iconComponent: Icons.Share,
        label: null,
        tooltip: 'Share',
      }
    ];

    return (
      <PanelHeader
        {...props}
        logoComponent={CustomKeplerGlLogo}
        actionItems={customActionItems}
      />
    );
  };

  CustomPanelHeader.defaultProps = {
    ...PanelHeader.defaultProps,
  };

  return CustomPanelHeader;
}

CustomPanelHeaderFactory.deps = [
  CustomSaveExportDropdownFactory,
  ...PanelHeaderFactory.deps
];

export function replacePanelHeader() {
  return [PanelHeaderFactory, CustomPanelHeaderFactory];
}
